
import { UserListDTO } from '../user/user-list.dto';
import { CalendarEventExcludedDateListDTO } from './calendar-event-excluded-date-list.dto';
import { CalendarEventReminderListDTO } from './calendar-event-reminder-list.dto';
import { ResourceListDTO } from '../resource/resource-list.dto';
import { ParticipantListDTO } from './participant-list.dto';

export class FullcalendarEventDTO {

    id: string;

    title: string;

    start: string | Date;

    end: string | Date;

    allDay: boolean;

    editable: boolean;

    backgroundColor: string;

    borderColor: string;

    textColor: string;

    startRecur: string;

    endRecur: string;

    startTime: string;

    endTime: string;

    rrule: string;

    duration: number;

    startEditable: boolean;

    durationEditable: boolean;

    resourceEditable: boolean;

    resourceId: string;

    rendering: string;

    extendedProps: {

        pending: boolean;

        rrule: string;

        duration: number;

        type: number;

        description: string;

        location: string;

        category: string;

        allowance: number;

        publicHoliday: boolean;

        excludedDate: Array<CalendarEventExcludedDateListDTO>;

        reminder: CalendarEventReminderListDTO;

        users: Array<ParticipantListDTO>;

        resources: Array<ResourceListDTO>;

        createdBy: string;

        updatedBy: string;

        createdAt: Date | string;

        updatedAt: Date | string;

    }

}
